import { Component, Ref, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ActionStatus, UserAction } from '@/application/types';
import { showError } from '@/application/snackbar/service';
import { GetProductIdentificationsByEANQuery, GetProductIdentificationsByProjectNumberQuery, ProductIdentification } from '../../types';

const productSearchState = namespace('productSearch');

@Component
export default class ProductSearch extends Vue {

  @productSearchState.Action
  readonly getProductIdentificationsByEAN!: UserAction<GetProductIdentificationsByEANQuery>;

  @productSearchState.Action
  readonly getProductIdentificationsByProjectNumber!: UserAction<GetProductIdentificationsByProjectNumberQuery>;

  @productSearchState.State
  readonly productIdentifications!: ProductIdentification[];

  @productSearchState.State
  readonly getProductIdentificationsByEANStatus!: ActionStatus;

  @productSearchState.State
  readonly getProductIdentificationsByProjectNumberStatus!: ActionStatus;

  @Ref('product-search')
  readonly productSearchField!: HTMLInputElement;

  search: string = '';

  get isProcessing(): boolean {
    return this.getProductIdentificationsByEANStatus === ActionStatus.InProgress
      || this.getProductIdentificationsByProjectNumberStatus === ActionStatus.InProgress;
  }

  mounted() {
    document.addEventListener('keydown', this.keyListener);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.keyListener);
  }

  keyListener(e: KeyboardEvent): void {
    if (e.key !== 'f') {
      return;
    }

    const exclude = ['input', 'textarea'];
    const source = e.target as HTMLElement;
    if (!source || exclude.includes(source.tagName.toLowerCase())) {
      return;
    }

    e.preventDefault();
    this.productSearchField.focus();
    // @ts-ignore
    this.productSearchField.$el.querySelector('input').select();
  }

  onSearchSubmit(): void {
    // Project number has a max length of 7, EAN or ISBN is longer
    if (this.search.length > 7) {
      // Strip - to convert ISBN to EAN
      const ean = this.search.replace(/-/g, '');
      const query: GetProductIdentificationsByEANQuery = {
        ean,
      };
      this.getProductIdentificationsByEAN(query)
        .then(() => {
          if (this.productIdentifications.length === 1) {
            const singleProductIdentification = this.productIdentifications[0];
            if (singleProductIdentification.id !== this.$route.params.id) {
              this.$router.push({ name: 'product-search/product-details', params: { id: singleProductIdentification.id } });
            }
          } else if (this.$route.name !== 'product-search/search') {
            this.$router.push({ name: 'product-search/search' });
          }
        })
        .catch((error) => {
          const message = error.response?.data.message || 'Die Suche ist fehlgeschlagen';
          showError({ message });
        });

      return;
    }

    // Search by project number
    const query: GetProductIdentificationsByProjectNumberQuery = {
      projectNumber: this.search,
    };
    this.getProductIdentificationsByProjectNumber(query)
      .then(() => {
        if (this.productIdentifications.length === 1) {
          const singleProductIdentification = this.productIdentifications[0];
          if (singleProductIdentification.id !== this.$route.params.id) {
            this.$router.push({ name: 'product-search/product-details', params: { id: singleProductIdentification.id } });
          }
        } else if (this.$route.name !== 'product-search/search') {
          this.$router.push({ name: 'product-search/search' });
        }
      })
      .catch((error) => {
        const message = error.response?.data.message || 'Die Suche ist fehlgeschlagen';
        showError({ message });
      });
  }

}
